"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOLSecurityHeaderKeys = void 0;
const EnumUtils_1 = require("../../utils/native/EnumUtils");
/**
 * These are the header keys that will be forwarded from the auth-forwarders for service level authorization
 */
var MOLSecurityHeaderKeys;
(function (MOLSecurityHeaderKeys) {
    // Singpass users
    MOLSecurityHeaderKeys["USER_ID"] = "mol-user-id";
    MOLSecurityHeaderKeys["USER_UINFIN"] = "mol-user-uinfin";
    MOLSecurityHeaderKeys["USER_AUTH_LEVEL"] = "mol-user-auth-level";
    MOLSecurityHeaderKeys["USER_PLATFORM"] = "mol-user-platform";
    // Corppass users
    MOLSecurityHeaderKeys["USER_UEN"] = "mol-user-uen";
    // Guest users
    MOLSecurityHeaderKeys["GUEST_ID"] = "mol-guest-id";
    // Used in AuthGuestEnhanced
    MOLSecurityHeaderKeys["GUEST_ENHANCED_ID"] = "mol-guest-enhanced-id";
    MOLSecurityHeaderKeys["GUEST_ENHANCED_EMAIL"] = "mol-guest-enhanced-email";
    // Citizen mobile OTP login
    MOLSecurityHeaderKeys["MOBILE_OTP_ID"] = "mol-mobile-otp-id";
    MOLSecurityHeaderKeys["MOBILE_OTP_PHONE_NUMBER"] = "mol-mobile-otp-phone-number";
    // Agency systems
    MOLSecurityHeaderKeys["AGENCY_APP_ID"] = "mol-agency-app-id";
    MOLSecurityHeaderKeys["AGENCY_NAME"] = "mol-agency-name";
    // FormSG webhooks
    MOLSecurityHeaderKeys["FORMSG_FORM_NAME"] = "mol-formsg-form-name";
    MOLSecurityHeaderKeys["FORMSG_FORM_ID"] = "mol-formsg-form-id";
    // Admin users (admin-auth-forwarder)
    MOLSecurityHeaderKeys["ADMIN_ID"] = "mol-admin-id";
    MOLSecurityHeaderKeys["ADMIN_USERNAME"] = "mol-admin-username";
    MOLSecurityHeaderKeys["ADMIN_UINFIN"] = "mol-admin-uinfin";
    MOLSecurityHeaderKeys["ADMIN_AGENCY_USER_ID"] = "mol-admin-agency-user-id";
    MOLSecurityHeaderKeys["ADMIN_EMAIL"] = "mol-admin-email";
    MOLSecurityHeaderKeys["ADMIN_NAME"] = "mol-admin-name";
    MOLSecurityHeaderKeys["ADMIN_GROUPS"] = "mol-admin-groups";
    // WOG SSO users
    MOLSecurityHeaderKeys["WOG_USER_ID"] = "wog-user-id";
    MOLSecurityHeaderKeys["WOG_USER_EMAIL"] = "wog-user-email";
    // System call
    MOLSecurityHeaderKeys["SYSTEM_ID"] = "mol-system-id";
    // SSO
    MOLSecurityHeaderKeys["SSO_USER_ID"] = "sso-user-id";
    MOLSecurityHeaderKeys["SSO_USER_AUTH_LEVEL"] = "sso-user-auth-level";
    MOLSecurityHeaderKeys["SSO_AGENCY_NAME"] = "sso-agency-name";
    MOLSecurityHeaderKeys["SSO_TYPE"] = "sso-type";
    // TODO: Temp headers for backwards compatibility
    MOLSecurityHeaderKeys["LEGACY_AUTH_TYPE"] = "mol-auth-type";
    MOLSecurityHeaderKeys["LEGACY_AUTH_LEVEL"] = "authlevel";
    MOLSecurityHeaderKeys["LEGACY_NRIC"] = "nric";
    MOLSecurityHeaderKeys["LEGACY_AGENCY"] = "agency";
    MOLSecurityHeaderKeys["LEGACY_AGENCY_APP_ID"] = "agency-app-id";
    // User role
    MOLSecurityHeaderKeys["USER_ROLES"] = "mol-user-roles";
})(MOLSecurityHeaderKeys || (exports.MOLSecurityHeaderKeys = MOLSecurityHeaderKeys = {}));
(function (MOLSecurityHeaderKeys) {
    MOLSecurityHeaderKeys.fn = {
        values: EnumUtils_1.EnumUtils.valuesFunc(MOLSecurityHeaderKeys),
    };
})(MOLSecurityHeaderKeys || (exports.MOLSecurityHeaderKeys = MOLSecurityHeaderKeys = {}));
//# sourceMappingURL=mol-security-headers.js.map